import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $location from 'wee-location';
import $fetch from 'wee-fetch';
import { _win } from 'core/variables';

class ViewAll {
    constructor() {
        this.$button = $(':viewAll');
        this.$container = $(':filteredItems');
        this.$pagination = $(':pagination');
        this.type = this.$button.data('type');
        this.category = $location.uri().query.category;
    }

    fetch(category) {
        $fetch.get(`${$location.uri().origin}/ajax/${this.type}`, {
            responseType: 'text',
            params: {
                all: true,
                category: category || this.category,
            },
        }).then(({ data }) => {
            this.$container.html(data);

            this.$pagination.hide();

            if (typeof this.category !== 'undefined') {
                _win.history.replaceState({
                    path: `/${this.type}`,
                }, null, `/${this.type}?category=${this.category}&all=true`);
            } else {
                _win.history.replaceState({
                    path: `/${this.type}`,
                }, null, `/${this.type}?all=true`);
            }

        }).catch(e => console.error(e));
    }
}

export default new RouteHandler({
    init() {
        const view = new ViewAll();

        $events.on(view.$button, 'click', () => {
            view.fetch();
        });
    },
});
